import apiClient from './client';

export const getCardChangeNotices = () =>
  apiClient.get('/api/card-changes/notices').then(r => r.data);

export const acknowledgeNotice = (noticeId) =>
  apiClient.post(`/api/card-changes/notices/${noticeId}/acknowledge`).then(r => r.data);

export const resolveEffectChoice = (noticeId, choice) =>
  apiClient.post(`/api/card-changes/notices/${noticeId}/resolve`, { choice }).then(r => r.data);
